/** @format */
import React, { FunctionComponent, ReactNode, useState } from 'react';

import { TabGroup } from './components/tab-group';
import { TabProps, TabVariant } from './components/tab-group/components/tab';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TabContent {
    activeTabIndex: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TabPanelProps {
    /*
     * The tabs to be displayed in the panel
     */
    tabs: TabProps[];

    /**
     * A function that when called should return the element to display
     */
    children: (args: TabContent) => ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
    variant?: TabVariant;
    onTabChange?: (tabIndex: number) => void;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
    children,
    onTabChange,
    ...otherProps
}: TabPanelProps) => {
    const [activeTabIndex, setActiveTab] = useState(0);

    return (
        <React.Fragment>
            <TabGroup
                activeIndex={activeTabIndex}
                onTabSelect={(index) => {
                    setActiveTab(index);
                    onTabChange?.(index);
                }}
                {...otherProps}
            />
            {children?.({ activeTabIndex })}
        </React.Fragment>
    );
};
